import { Component, forwardRef, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { takeUntil } from 'rxjs';
import { HeadquartersService } from 'src/app/shared/api-services/headquarters.service';
import { Headquarter } from 'src/app/shared/models/headquarter/headquarter';
import { BaseAutocompleteComponent } from '../base-autocomplete/base-autocomplete.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'headquarter-autocomplete',
  imports: [
    TranslateModule,
    AutoCompleteModule,
    CommonModule
  ],
  template: `
    <p-autoComplete
      class="w-100"
      [placeholder]="placeholder | translate"
      [showClear]="true"
      [forceSelection]="true"
      [suggestions]="listItems"
      (completeMethod)="getItems($event.query)"
      (onClear)="onClearItem()"
      (onSelect)="onSelectItem($event)"
      [ngClass]="{'has-value': hasValue}"
      optionLabel="name" />
  `,
  styleUrls: ['../base-autocomplete/base-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HeadquarterAutocompleteComponent),
      multi: true
    }
  ]
})
export class HeadquarterAutocompleteComponent extends BaseAutocompleteComponent<Headquarter, void> implements OnInit, OnChanges {
  @Input() initialHeadquarter: Headquarter | null = null;
  @Input() headquarterId: string | null = null;

  constructor(private _headquartersService: HeadquartersService) {
    super();
  }

  ngOnInit(): void {
    this.loadInitialHeadquarter();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headquarterId'] || changes['initialHeadquarter']) {
      this.loadInitialHeadquarter();
    }
  }

  private loadInitialHeadquarter(): void {
    if (this.initialHeadquarter) {
      this.listItems = [{ name: this.initialHeadquarter.name, item: this.initialHeadquarter }];
      this.hasValue = true;
      setTimeout(() => {
        this.onSelectedItem.emit(this.initialHeadquarter);
        this.placeholder = this.initialHeadquarter?.name || this.placeholder;
      }, 0);
    } else if (this.headquarterId) {
      this._headquartersService.getHeadquarter$(this.headquarterId)
        .pipe(takeUntil(this._destroy$))
        .subscribe(headquarter => {
          if (headquarter) {
            this.listItems = [{ name: headquarter.name, item: headquarter }];
            this.hasValue = true;
            setTimeout(() => {
              this.onSelectedItem.emit(headquarter);
              this.placeholder = headquarter.name || this.placeholder;
            }, 0);
          }
        });
    }
  }

  override getItems(query: string): void {
    this._headquartersService.listHeadquarters$({ nameContains: query, limit: this.limit })
      .pipe(takeUntil(this._destroy$))
      .subscribe((response) => {
        this.listItems = response.items.map((headquarter) => ({ name: headquarter.name, item: headquarter }));
      });
  }
}